import { useEffect, useRef, useState } from 'react'
import { createModel } from 'hox'
import { TablePaginationConfig } from 'antd/es/table/interface'
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE } from '@/utils/constants'
import { ledgerService } from '../../ledgerService'
import useGlobalModel, { transPgToPagination } from '@/model/globalModel'
import { ISearchPage } from '@/types/AppTypes'

export const vehicleDetialModel = createModel(function () {
    //查看详情form
    const [detailLookList, setDetailLookList] = useState<any>([])
    //分页参数
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }
    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg)
    //表格多选id值
    const [selectedRowKeys, setSelectedRowKeys] = useState<any>([])
    const pgCfgRef = useRef<TablePaginationConfig>(initPgCfg)
    //查询条件
    const [detialSearchValues, setDetialSearchValues] = useState<any>({ pcode: '' })
    const [imgVisible, setImgVisible] = useState(false)
    useEffect(() => {
        pgCfgRef.current = pgCfg
    }, [pgCfg])
    const {
        user: { shopCode, createUser, userType },
    } = useGlobalModel(({ user }) => [user])
    //列表查询
    const getOne = async (page: ISearchPage = pgCfgRef.current, id) => {
        const searchParams = {
            createUserId: shopCode,
            schedulingId: id,
            // pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
            // pageNum: (page?.current || page?.pageNum) ?? DEFAULT_FIRST_PAGE_NUM,
            pageSize: -1,
            pageNum: 1,
            createUser: userType === '超级管理员' ? '' : createUser,
            // pageSize: -1,
            // pageNum: 1,
        }
        let { retData } = await ledgerService.one(searchParams)
        const { records } = retData
        // setPgCfg(transPgToPagination(pg));
        setPgCfg(
            transPgToPagination({
                total: records.length,
                size: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
                current: (page?.current || page?.pageNum) ?? DEFAULT_FIRST_PAGE_NUM,
            }),
        )
        setDetailLookList(records)
    }

    return {
        /***field***/
        initPgCfg,
        selectedRowKeys,
        pgCfg,
        detailLookList,
        detialSearchValues,
        imgVisible,
        /***method***/
        setImgVisible,
        setDetialSearchValues,
        setDetailLookList,
        setSelectedRowKeys,
        getOne,
        setPgCfg,
    }
})
